import React, { useState } from 'react';

const InscricaoDepylExpress = () => {
  const [formData, setFormData] = useState({
    nomeCompleto: '',
    cpf: '',
    rg: '',
    dataNascimento: '',
    sexo: '',
    telefone: '',
    celular: '',
    email: '',
    cep: '',
    endereco: '',
    numero: '',
    complemento: '',
    bairro: '',
    cidade: '',
    estado: '',
    profissao: '',
    experienciaDepilacao: '',
    motivacao: '',
    disponibilidade: '',
    investimento: '',
    termos: false
  });

  const [showSuccess, setShowSuccess] = useState(false);
  const [errors, setErrors] = useState({});

  const pacotes = [
    {
      nome: 'Pacote Básico',
      preco: 'R$ 2.500,00',
      descricao: 'Ideal para quem está começando',
      inclui: [
        'Kit inicial completo',
        'Treinamento de 16 horas',
        'Certificado de conclusão',
        'Suporte por 30 dias',
        'Manual técnico'
      ]
    },
    {
      nome: 'Pacote Profissional',
      preco: 'R$ 4.200,00',
      descricao: 'Para quem quer se profissionalizar',
      inclui: [
        'Tudo do Pacote Básico',
        'Kit avançado de produtos',
        'Treinamento de 32 horas',
        'Acompanhamento por 90 dias',
        'Marketing digital básico',
        'Certificação avançada'
      ]
    },
    {
      nome: 'Pacote Master',
      preco: 'R$ 6.800,00',
      descricao: 'Completo para empreendedores',
      inclui: [
        'Tudo do Pacote Profissional',
        'Kit premium completo',
        'Treinamento de 48 horas',
        'Mentoria por 6 meses',
        'Plano de negócios',
        'Suporte jurídico básico',
        'Certificação master'
      ]
    }
  ];

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    
    // Limpar erro quando o usuário começar a digitar
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.nomeCompleto.trim()) newErrors.nomeCompleto = 'Nome completo é obrigatório';
    if (!formData.cpf.trim()) newErrors.cpf = 'CPF é obrigatório';
    if (!formData.email.trim()) newErrors.email = 'Email é obrigatório';
    if (!formData.telefone.trim()) newErrors.telefone = 'Telefone é obrigatório';
    if (!formData.investimento) newErrors.investimento = 'Selecione um pacote';
    if (!formData.termos) newErrors.termos = 'Você deve aceitar os termos';
    
    // Validação de email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (formData.email && !emailRegex.test(formData.email)) {
      newErrors.email = 'Email inválido';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (validateForm()) {
      // Simular envio do formulário
      console.log('Dados do formulário:', formData);
      setShowSuccess(true);
      
      // Resetar formulário após 3 segundos
      setTimeout(() => {
        setShowSuccess(false);
        setFormData({
          nomeCompleto: '',
          cpf: '',
          rg: '',
          dataNascimento: '',
          sexo: '',
          telefone: '',
          celular: '',
          email: '',
          cep: '',
          endereco: '',
          numero: '',
          complemento: '',
          bairro: '',
          cidade: '',
          estado: '',
          profissao: '',
          experienciaDepilacao: '',
          motivacao: '',
          disponibilidade: '',
          investimento: '',
          termos: false
        });
      }, 3000);
    }
  };

  if (showSuccess) {
    return (
      <div className="pt-32 min-h-screen bg-focus-white flex items-center justify-center">
        <div className="bg-white rounded-lg shadow-xl p-8 max-w-md mx-4 text-center">
          <div className="text-6xl mb-4">🎉</div>
          <h2 className="text-2xl font-bold text-focus-blue mb-4">
            Inscrição Enviada com Sucesso!
          </h2>
          <p className="text-gray-600 mb-6">
            Recebemos sua inscrição para o Depyl Express. Nossa equipe entrará em contato em até 24 horas para agendar sua entrevista.
          </p>
          <div className="bg-focus-pink p-4 rounded-lg">
            <p className="text-sm text-gray-700">
              <strong>Próximos passos:</strong><br/>
              1. Análise do perfil<br/>
              2. Entrevista por telefone<br/>
              3. Agendamento do treinamento<br/>
              4. Início da jornada empreendedora
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="pt-32 bg-focus-white min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-focus-orange to-red-600 text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Inscrição Depyl Express
          </h1>
          <p className="text-xl text-red-100 max-w-2xl mx-auto">
            Transforme sua vida profissional com o negócio de depilação que mais cresce no Brasil
          </p>
        </div>
      </section>

      {/* Sobre o Depyl Express */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
            <div>
              <h2 className="text-3xl font-bold text-focus-blue mb-6">
                Por que escolher o Depyl Express?
              </h2>
              <p className="text-lg text-gray-600 mb-6">
                O Depyl Express é uma oportunidade única de empreender no segmento de beleza e estética, 
                com um modelo de negócio comprovado e lucrativo.
              </p>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <svg className="w-6 h-6 text-green-500 mr-3 mt-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700">Mercado em constante crescimento</span>
                </li>
                <li className="flex items-start">
                  <svg className="w-6 h-6 text-green-500 mr-3 mt-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700">Baixo investimento inicial</span>
                </li>
                <li className="flex items-start">
                  <svg className="w-6 h-6 text-green-500 mr-3 mt-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700">Retorno rápido do investimento</span>
                </li>
                <li className="flex items-start">
                  <svg className="w-6 h-6 text-green-500 mr-3 mt-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700">Suporte completo da franquia</span>
                </li>
                <li className="flex items-start">
                  <svg className="w-6 h-6 text-green-500 mr-3 mt-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700">Flexibilidade de horários</span>
                </li>
              </ul>
            </div>
            <div className="bg-focus-pink rounded-lg p-8">
              <h3 className="text-2xl font-bold text-focus-blue mb-6">Números que impressionam</h3>
              <div className="grid grid-cols-2 gap-4 text-center">
                <div className="bg-white p-4 rounded-lg">
                  <div className="text-2xl font-bold text-focus-orange">500+</div>
                  <div className="text-sm text-gray-600">Franqueados</div>
                </div>
                <div className="bg-white p-4 rounded-lg">
                  <div className="text-2xl font-bold text-focus-orange">95%</div>
                  <div className="text-sm text-gray-600">Satisfação</div>
                </div>
                <div className="bg-white p-4 rounded-lg">
                  <div className="text-2xl font-bold text-focus-orange">R$ 3k</div>
                  <div className="text-sm text-gray-600">Faturamento médio</div>
                </div>
                <div className="bg-white p-4 rounded-lg">
                  <div className="text-2xl font-bold text-focus-orange">6 meses</div>
                  <div className="text-sm text-gray-600">Retorno do investimento</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pacotes Disponíveis */}
      <section className="py-16 bg-focus-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-focus-blue text-center mb-12">
            Escolha seu Pacote de Investimento
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            {pacotes.map((pacote, index) => (
              <div
                key={index}
                className={`rounded-lg shadow-lg p-6 border-2 transition-all cursor-pointer ${
                  formData.investimento === pacote.nome
                    ? 'border-focus-orange bg-orange-50'
                    : 'border-gray-200 bg-white hover:border-focus-orange'
                }`}
                onClick={() => setFormData(prev => ({ ...prev, investimento: pacote.nome }))}
              >
                <h3 className="text-xl font-bold text-focus-blue mb-2">{pacote.nome}</h3>
                <div className="text-2xl font-bold text-focus-orange mb-2">{pacote.preco}</div>
                <p className="text-gray-600 text-sm mb-4">{pacote.descricao}</p>
                <ul className="space-y-2">
                  {pacote.inclui.map((item, idx) => (
                    <li key={idx} className="flex items-center text-sm text-gray-600">
                      <svg className="w-4 h-4 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Formulário de Inscrição */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-focus-blue text-center mb-12">
              Formulário de Inscrição
            </h2>
            
            <form onSubmit={handleSubmit} className="bg-white rounded-lg shadow-lg p-8">
              {/* Dados Pessoais */}
              <div className="mb-8">
                <h3 className="text-xl font-semibold text-focus-blue mb-6 border-b border-gray-200 pb-2">
                  Dados Pessoais
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Nome Completo *
                    </label>
                    <input
                      type="text"
                      name="nomeCompleto"
                      value={formData.nomeCompleto}
                      onChange={handleInputChange}
                      className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-focus-orange ${
                        errors.nomeCompleto ? 'border-red-500' : 'border-gray-300'
                      }`}
                      placeholder="Digite seu nome completo"
                    />
                    {errors.nomeCompleto && <p className="text-red-500 text-sm mt-1">{errors.nomeCompleto}</p>}
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      CPF *
                    </label>
                    <input
                      type="text"
                      name="cpf"
                      value={formData.cpf}
                      onChange={handleInputChange}
                      className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-focus-orange ${
                        errors.cpf ? 'border-red-500' : 'border-gray-300'
                      }`}
                      placeholder="000.000.000-00"
                    />
                    {errors.cpf && <p className="text-red-500 text-sm mt-1">{errors.cpf}</p>}
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      RG
                    </label>
                    <input
                      type="text"
                      name="rg"
                      value={formData.rg}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-focus-orange"
                      placeholder="00.000.000-0"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Data de Nascimento
                    </label>
                    <input
                      type="date"
                      name="dataNascimento"
                      value={formData.dataNascimento}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-focus-orange"
                    />
                  </div>
                  
                  <div className="md:col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Sexo
                    </label>
                    <select
                      name="sexo"
                      value={formData.sexo}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-focus-orange"
                    >
                      <option value="">Selecione</option>
                      <option value="masculino">Masculino</option>
                      <option value="feminino">Feminino</option>
                      <option value="outro">Outro</option>
                    </select>
                  </div>
                </div>
              </div>

              {/* Contato */}
              <div className="mb-8">
                <h3 className="text-xl font-semibold text-focus-blue mb-6 border-b border-gray-200 pb-2">
                  Contato
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Telefone *
                    </label>
                    <input
                      type="tel"
                      name="telefone"
                      value={formData.telefone}
                      onChange={handleInputChange}
                      className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-focus-orange ${
                        errors.telefone ? 'border-red-500' : 'border-gray-300'
                      }`}
                      placeholder="(11) 1234-5678"
                    />
                    {errors.telefone && <p className="text-red-500 text-sm mt-1">{errors.telefone}</p>}
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Celular
                    </label>
                    <input
                      type="tel"
                      name="celular"
                      value={formData.celular}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-focus-orange"
                      placeholder="(11) 99999-9999"
                    />
                  </div>
                  
                  <div className="md:col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Email *
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-focus-orange ${
                        errors.email ? 'border-red-500' : 'border-gray-300'
                      }`}
                      placeholder="seu@email.com"
                    />
                    {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
                  </div>
                </div>
              </div>

              {/* Endereço */}
              <div className="mb-8">
                <h3 className="text-xl font-semibold text-focus-blue mb-6 border-b border-gray-200 pb-2">
                  Endereço
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      CEP
                    </label>
                    <input
                      type="text"
                      name="cep"
                      value={formData.cep}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-focus-orange"
                      placeholder="00000-000"
                    />
                  </div>
                  
                  <div className="md:col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Endereço
                    </label>
                    <input
                      type="text"
                      name="endereco"
                      value={formData.endereco}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-focus-orange"
                      placeholder="Rua, Avenida, etc."
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Número
                    </label>
                    <input
                      type="text"
                      name="numero"
                      value={formData.numero}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-focus-orange"
                      placeholder="123"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Complemento
                    </label>
                    <input
                      type="text"
                      name="complemento"
                      value={formData.complemento}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-focus-orange"
                      placeholder="Apto, Bloco, etc."
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Bairro
                    </label>
                    <input
                      type="text"
                      name="bairro"
                      value={formData.bairro}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-focus-orange"
                      placeholder="Nome do bairro"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Cidade
                    </label>
                    <input
                      type="text"
                      name="cidade"
                      value={formData.cidade}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-focus-orange"
                      placeholder="Nome da cidade"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Estado
                    </label>
                    <select
                      name="estado"
                      value={formData.estado}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-focus-orange"
                    >
                      <option value="">Selecione</option>
                      <option value="SP">São Paulo</option>
                      <option value="RJ">Rio de Janeiro</option>
                      <option value="MG">Minas Gerais</option>
                      <option value="RS">Rio Grande do Sul</option>
                      <option value="PR">Paraná</option>
                      <option value="SC">Santa Catarina</option>
                    </select>
                  </div>
                </div>
              </div>

              {/* Informações Profissionais */}
              <div className="mb-8">
                <h3 className="text-xl font-semibold text-focus-blue mb-6 border-b border-gray-200 pb-2">
                  Perfil Empreendedor
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Profissão Atual
                    </label>
                    <input
                      type="text"
                      name="profissao"
                      value={formData.profissao}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-focus-orange"
                      placeholder="Sua profissão atual"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Experiência com Depilação
                    </label>
                    <select
                      name="experienciaDepilacao"
                      value={formData.experienciaDepilacao}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-focus-orange"
                    >
                      <option value="">Selecione</option>
                      <option value="nenhuma">Nenhuma experiência</option>
                      <option value="basica">Experiência básica</option>
                      <option value="intermediaria">Experiência intermediária</option>
                      <option value="avancada">Experiência avançada</option>
                    </select>
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Disponibilidade de Tempo
                    </label>
                    <select
                      name="disponibilidade"
                      value={formData.disponibilidade}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-focus-orange"
                    >
                      <option value="">Selecione</option>
                      <option value="meio-periodo">Meio período</option>
                      <option value="periodo-integral">Período integral</option>
                      <option value="fins-semana">Fins de semana</option>
                      <option value="flexivel">Horário flexível</option>
                    </select>
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Principal Motivação
                    </label>
                    <select
                      name="motivacao"
                      value={formData.motivacao}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-focus-orange"
                    >
                      <option value="">Selecione</option>
                      <option value="renda-extra">Renda extra</option>
                      <option value="mudanca-carreira">Mudança de carreira</option>
                      <option value="independencia-financeira">Independência financeira</option>
                      <option value="empreender">Vontade de empreender</option>
                      <option value="flexibilidade">Flexibilidade de horários</option>
                    </select>
                  </div>
                </div>
              </div>

              {/* Pacote Escolhido */}
              <div className="mb-8">
                <h3 className="text-xl font-semibold text-focus-blue mb-6 border-b border-gray-200 pb-2">
                  Pacote de Investimento
                </h3>
                <div className="bg-orange-50 p-4 rounded-lg">
                  {formData.investimento ? (
                    <p className="text-focus-blue font-semibold">
                      Pacote selecionado: {formData.investimento}
                    </p>
                  ) : (
                    <p className="text-gray-600">
                      Selecione um pacote acima para continuar
                    </p>
                  )}
                  {errors.investimento && <p className="text-red-500 text-sm mt-1">{errors.investimento}</p>}
                </div>
              </div>

              {/* Termos e Condições */}
              <div className="mb-8">
                <div className="flex items-start">
                  <input
                    type="checkbox"
                    name="termos"
                    checked={formData.termos}
                    onChange={handleInputChange}
                    className="mt-1 mr-3"
                  />
                  <label className="text-sm text-gray-700">
                    Eu aceito os <a href="#" className="text-focus-orange hover:underline">termos e condições</a> e 
                    a <a href="#" className="text-focus-orange hover:underline">política de privacidade</a> do Depyl Express. 
                    Autorizo o contato para apresentação da oportunidade de negócio. *
                  </label>
                </div>
                {errors.termos && <p className="text-red-500 text-sm mt-1">{errors.termos}</p>}
              </div>

              {/* Botão de Envio */}
              <div className="text-center">
                <button
                  type="submit"
                  className="bg-focus-orange hover:bg-red-600 text-white px-8 py-3 rounded-lg text-lg font-semibold transition-colors"
                >
                  Enviar Inscrição
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default InscricaoDepylExpress;